<template>
  <div class="index">
    <dvmsHeader/>
    <div class="headeritem" ></div>
     
     <div class="main">
        <router-link to="/intr"></router-link>
        <router-view>
        </router-view>
     </div>
     <!-- <Footer/> -->
  </div>
</template>

<script>
import Footer from "@/components/footer.vue"
// import dvmsHeader from "@/components/dvmsheader.vue"
import dvmsHeader from "@/components/header2.vue"
import Aside from "@/components/aside.vue"
export default {
  name: 'IndexView',
  components: {
    Footer,
    dvmsHeader,
    Aside
  },
  data(){
    return{
      message:'hello',
      
    };
  },
  mounted(){
  
   this.init()
   
  },
  methods:{
    init(){
      console.log(this.message)
    }
  }


  
}
</script>
<style>
.index{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}
.main{
  margin-top: 16.6vh;
  background-color: #f0f0f4;
  height: 83.4vh;
  
    /* flex:1;
    display: flex;
    flex-direction: row;
    min-height: 0; */
     /* 关键属性 */
  
}

.headeritem{
  /* height: 152px !important; */
  width: 100% !important;
  
}
</style>